import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadChallanReportPdf = (reportData, companyName, logo, setOpenBackdrop) => {
    if (!reportData || reportData.length === 0) {
        alert("No data found to generate report!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        let currentY = 15;

        // --- 1. Header Section (Static for the first page) ---
       // --- 1. Header Section ---
        if (logo) {
            doc.addImage(logo, 'PNG', 14, 8, 12, 12); // Logo thoda chota kiya
        }

        // Company Name (Small and Left)
        doc.setFontSize(12);
        doc.setTextColor(80); // Thoda dark grey
        doc.setFont("helvetica", "normal");
        doc.text(companyName || 'COMPANY NAME', logo ? 28 : 14, 16);
        
        // Report Title (Centered & Bold)
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFontSize(16);
        doc.setTextColor(25, 118, 210); // Professional Blue
        doc.setFont("helvetica", "bold");
        const title = 'CHALLAN SUMMARY REPORT';
        const titleWidth = doc.getTextWidth(title);
        doc.text(title, (pageWidth - titleWidth) / 2, 25); // Perfect Center Alignment

        // Underline
        doc.setDrawColor(200); // Light line color
        doc.setLineWidth(0.5);
        doc.line(14, 28, 196, 28);
        
        currentY = 38; // Content thoda niche se start hoga

        // Iterate through each Customer
        reportData.forEach((customer, custIdx) => {
            // Check for page overflow
            if (currentY > 250) {
                doc.addPage();
                currentY = 20;
            }

            // Customer Header
            doc.setFillColor(240, 240, 240);
            doc.rect(14, currentY, 182, 8, 'F');
            doc.setFontSize(11);
            doc.setFont("helvetica", "bold");
            doc.setTextColor(0);
            doc.text(`Customer: ${customer.contact_name} (${customer.address})`, 16, currentY + 6);
            currentY += 12;

            // Iterate through each Challan of the Customer
            customer.challans.forEach((challan, chalIdx) => {
                
                doc.setFontSize(10);
                doc.setFont("helvetica", "bold");
                doc.setTextColor(50);
                doc.text(`Challan No: ${challan.challan_no} | Date: ${new Date(challan.challan_date).toISOString().slice(0, 10)}`, 14, currentY);
                currentY += 4;

                // Items Table for this Challan
                const tableHeaders = [['S.No', 'Item Name', 'Qty', 'Rate', 'Amount']];
                const tableData = (challan.items || []).map((item, idx) => [
                    idx + 1,
                    item.itemname,
                    item.qty,
                    `Rs. ${Number(item.rate).toFixed(2)}`,
                    `Rs. ${Number(item.amount).toFixed(2)}`
                ]);

                doc.autoTable({
                    startY: currentY,
                    head: tableHeaders,
                    body: tableData,
                    theme: 'grid',
                    headStyles: { fillColor: [70, 70, 70], fontSize: 9 },
                    styles: { fontSize: 8, cellPadding: 2 },
                    columnStyles: {
                        0: { cellWidth: 10 },
                        2: { halign: 'center' },
                        3: { halign: 'right' },
                        4: { halign: 'right' },
                    },
                    margin: { left: 14 },
                    didDrawPage: (data) => {
                        currentY = data.cursor.y;
                    }
                });

                currentY = doc.lastAutoTable.finalY;

                // Challan Total
                doc.setFontSize(9);
                doc.setFont("helvetica", "bold");
                doc.text(`Challan Total: Rs. ${Number(challan.total_amount).toFixed(2)}`, 196, currentY + 6, { align: 'right' });
                
                currentY += 12; // Gap before next challan or customer

                // Page break check
                if (currentY > 270) {
                    doc.addPage();
                    currentY = 20;
                }
            });

            currentY += 5; // Extra gap between customers
        });

        // Footer (Page Numbers)
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(150);
            doc.text(`Page ${i} of ${totalPages}`, 105, 290, { align: 'center' });
        }

        const timestamp = new Date().toISOString().split('T')[0];
        doc.save(`Challan_Report_${timestamp}.pdf`);

    } catch (error) {
        console.error("PDF Error:", error);
        alert("Error generating PDF");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadChallanReportPdf;